<template>
  <div id = "bg">
    <div class = "img"></div>
    <h1>Sorry, but applications have closed.</h1>
    <!-- <h1>Yay, You're Applying!</h1>
    <h4>But first, here’s a message from MISA’s president for all aspiring officers.</h4>

    <h4><b>Message from the President:</b></h4>
    <h4>First and foremost, I would like to thank you for showing interest in taking in a leadership 
    role in the organization. It is always a pleasure to have someone interested in carrying out MISA's advocacy. Now, it is without a doubt that being an associate will defintely pose challenges. However, I want you to know that you will not be facing these alone. I can assure you that this family will guide you every step of the way.
    <br><br>I wish you all the best and we cannot wait to hear what you have in store of us!</h4>

    <h5><br>Are you ready for the next step?</h5>
    <button class = "primary-btn" id = "bt-popup">Let's go!</button> -->
  </div>
</template>

<script>
  import * as typeformEmbed from '@typeform/embed'
  // import VModal from 'vue-js-modal'
  export default {
    name: 'Apply',
    // props: {
    //   msg: String
    // }
    methods: {
    },
    mounted(){
          const popupApp = typeformEmbed.makePopup(
              'https://erinyabut.typeform.com/to/ANs7F7To',
                {        
                  hideHeaders: true,
                  hideFooter: true,
                  onSubmit: function () {
                    console.log('Typeform successfully submitted')
                  },
                  onReady: function () {
                    console.log('Typeform is ready')
                  }
                }
              )
      document.getElementById('bt-popup').addEventListener('click', function () {
        popupApp.open();
      });
      this.showModal();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  button{
    padding: 0.40vw;
    font-size: 1.75vw;
    width: 14.34vw;
    margin-left: 19.76vw;
    position: relative;
    margin-bottom: 80px;
  }
  #bg{
    top:0;
    left:0;
    bottom:0;
    right:0;
    margin-bottom: 40px;
  }
  #bg .img{
    position: absolute;
    background-position: 
      top 10vw left 0vw,
      bottom 0vw left 83.8vw;
      
    background-image: 
    url('~@/assets/blob2.png'),
    url('~@/assets/blob1.png');
    
    width: 100%;
    height:50.5vw;
    background-size:15vw;
    background-repeat: no-repeat;
    /* overflow: auto; */
  }

  @media only screen and (max-width: 1353px) {
      .img{
          display: none;
      }
    }

  h1{
    margin-top: 64px;
    margin-left: 18.30vw;
    margin-right: 16vw;
    max-width: 840px;
  }
  h4, h5{
    margin-left: 19.76vw;
    margin-right: 16vw;
    font-weight: lighter;
    max-width: 840px;
  }
</style>